export default __webpack_public_path__ + "static/blog-1-635113bab4bc8629660d2356ce6ee986.jpg";